const users = {
  listTitle: "Account Administrators",
  listSubtitle: "Manage the administrators linked to each company account.",
  addAdmin: "Add Admin",
  stats: {
    title: "Account administrator statistics",
    accounts: "Companies",
    active: "Active administrators",
    inactive: "Inactive administrators",
    admins: "Total administrators",
    loading: "Loading",
    error: "Unavailable",
  },
  filters: {
    title: "Administrator filters",
    search: "Search",
    searchPlaceholder: "Search by name, username, email or company",
    status: "Status",
    allStatuses: "All statuses",
    archivedAt: "Archive date",
    archivedAtPlaceholder: "Select a date range",
    clearDateRange: "Clear date range",
  },
  datePicker: {
    nextMonth: "Next month",
    previousMonth: "Previous month",
  },
  table: {
    name: "Administrator",
    username: "Username",
    email: "Email",
    company: "Company",
    status: "Status",
    createdAt: "Created at",
    archivedAt: "Archive date",
    actions: "Actions",
    empty: "No account admins match these filters.",
    error: "Account admins could not be loaded.",
    loading: "Loading account admins",
    showingCount: "Showing {{count}} of {{total}}",
    rowsPerPageLabel: "Rows per page",
    nextPage: "Next page",
    previousPage: "Previous page",
    pagination: "Pagination",
    sortAscending: "Sort ascending",
    sortDescending: "Sort descending",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    pendingActivation: "Pending activation",
  },
  actionMenu: {
    trigger: "Administrator actions",
  },
  actions: {
    view: "View",
    edit: "Edit",
    delete: "Delete",
    resendActivation: "Resend activation",
    restore: "Restore",
  },
  archivedAdmins: {
    title: "Archived Account Admins",
    subtitle: "Administrators that have been archived and can be restored.",
    empty: "No archived account admins match these filters.",
  },
  form: {
    createTitle: "Add Account Admin",
    createSubtitle:
      "Enter the administrator's details and link them to a company.",
    editTitle: "Edit Account Admin",
    editSubtitle: "Update the administrator's details.",
    fullNameHelper: "Must be a full three-part name",
    mainInformation: "Main Information",
    nameEn: "English name",
    nameAr: "Arabic name",
    username: "Username",
    email: "Email",
    phoneNumber: "Phone number",
    company: "Company",
    companyPlaceholder: "Select a company",
    countrySelectAriaLabel: "Country code",
    isActive: "Active",
    isActiveDescription: "Inactive administrators cannot sign in.",
    statusDialog: {
      titleActivate: "Activate Administrator",
      titleDeactivate: "Deactivate Administrator",
      questionActivate: "Are you sure you want to activate this administrator?",
      questionDeactivate:
        "Are you sure you want to deactivate this administrator?",
      note: "This change won't be applied until you save.",
      yes: "Yes",
      no: "No",
      close: "Close status change dialog",
    },
    countries: {
      ksa: "Saudi Arabia",
      egypt: "Egypt",
      uae: "United Arab Emirates",
      jordan: "Jordan",
    },
    submitCreate: "Create Admin",
    submitEdit: "Save Changes",
    cancel: "Cancel",
    loading: "Loading administrator",
    loadError: "The administrator could not be loaded.",
    empty: "This administrator could not be found.",
    createSuccessFallback: "Created successfully",
  },
  restoreDialog: {
    title: "Restore Admin",
    question:
      "An admin with the same details already exists in the archived admins",
    prompt: "Do you want to restore this admin?",
    cancel: "Cancel",
    confirm: "Restore Admin",
    close: "Close restore dialog",
    successFallback: "Admin restored successfully.",
    errorFallback: "The admin could not be restored.",
  },
  restoreArchivedAdminDialog: {
    title: "Restore Account Admin",
    question: "Are you sure you want to restore this account admin?",
    prompt:
      "The account admin will become active again and usable in the system.",
    cancel: "Cancel",
    confirm: "Restore Account Admin",
    close: "Close restore dialog",
    successFallback: "Admin restored successfully.",
    errorFallback: "The admin could not be restored.",
  },
  validation: {
    usernameInvalid:
      "Username must be 3 to 30 characters and contain only letters, numbers, dots, underscores, or hyphens.",
    phoneRequired: "Phone number is required.",
    phoneInvalid: "Enter a valid phone number.",
  },
  detail: {
    loading: "Loading administrator",
    error: "The administrator could not be loaded.",
    empty: "This administrator could not be found.",
    mainInformation: "Main Information",
    profileTitle: "Profile",
    accountDetailsTitle: "Account admin details",
    fullName: "Full name",
    activationStatus: "Activation status",
    username: "Username",
    email: "Email",
    phoneNumber: "Phone number",
    company: "Company",
    status: "Status",
    twoFactor: "Two-factor authentication",
    twoFactorEnabled: "Enabled",
    twoFactorDisabled: "Disabled",
    createdAt: "Created at",
    updatedAt: "Last updated",
    back: "Back to administrators",
    editAction: "Edit",
    deleteAction: "Delete",
    resendActivationAction: "Resend activation",
    deleteTitle: "Delete this administrator?",
    deleteDescription: "This action is permanent and cannot be undone.",
    confirmDelete: "Delete",
    cancelDelete: "Cancel",
    closeDelete: "Close",
    resendTitle: "Resend the activation link?",
    resendDescription:
      "A new activation link will be sent to the administrator's email address.",
    confirmResend: "Resend",
    cancelResend: "Cancel",
    closeResend: "Close",
  },
};

export default users;
